export const ITEMS_PER_PAGE = 20;
export let PAGING = {
    page: 1,
    itemsPerPage: ITEMS_PER_PAGE,
    maxSize: 5,
    numPages: 1,
    length: 0
};



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/constants/pagination.constants.ts